import { appFormUtil } from 'modules/common';
import { StyledMultiPartUploadField } from 'modules/components/layer01';
import React from 'react';

export type UploadDailyReportPhotoFieldProps<T extends object, K extends keyof T = keyof T> = {
  form: appFormUtil.InferReturn<T>;
  fieldName: K;
  uploadInProgressFieldName: K;
  uploadCountFieldName: K;
};

export const FC = <T extends object>(props: UploadDailyReportPhotoFieldProps<T>) => {

  return (
    <StyledMultiPartUploadField.FC
      fieldName={props.fieldName}
      isMultiUpload={true}
      form={props.form}
      isUploadingFieldName={props.uploadInProgressFieldName}
      uploadCountFieldName={props.uploadCountFieldName}
    />

  );
};
